import React from "react";
import {
  Footer,
  FooterContainer,
  FooterCopyright,
  FooterLink,
  FooterList,
  FooterNav,
} from "@deere/fuel-react";
const FomFooter = (props) => {
  return (
    <Footer>
      <FooterNav aria-label="footer navigation">
        <FooterList>
          <FooterLink href="/home" text="Home" />
          <FooterLink
            href="mailto:ShippingOrder@JohnDeere.com"
            title="ShippingOrder@JohnDeere.com"
            text="Contact Us"
          />
          {/* <FooterLink
            href="https://github.deere.com/ux/uxframe"
            text="GitHub"
          /> */}
          {/* <FooterLink
            href="https://www.yammer.com/johndeere.com/#/threads/inGroup?type=in_group&amp;feedId=15611067&amp;view=all"
            text="Yammer"
          />
          <FooterLink
            href="https://johndeere.cvent.com/pub/eMarketing/Pages/SignUp.aspx?p=2a69c63b-ace1-454f-bbe3-e371c5a09d58&amp;m="
            text="Newsletter"
          /> */}
          <FooterLink
            href="https://www.deere.com/en/privacy-and-data/"
            text="Privacy & Data"
          />
          <FooterLink
            href="https://www.deere.com/en/privacy-and-data/terms/"
            text="Terms of Use"
          />
        </FooterList>
      </FooterNav>
    </Footer>
  );
};
export default FomFooter;
